import React from 'react';
import { howItWorks } from '../../data/mock';

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="bg-black py-24 lg:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="max-w-2xl mb-16">
          <h2 className="text-3xl md:text-4xl font-semibold text-white leading-tight tracking-tight mb-4">
            How It Works
          </h2>
          <p className="text-white/60 text-lg leading-relaxed">
            Three simple steps to secure, organized documentation.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {howItWorks.map((step, index) => (
            <div key={step.step} className="relative">
              {/* Connector Line (hidden on mobile, shown between items on desktop) */}
              {index < howItWorks.length - 1 && (
                <div className="hidden md:block absolute top-8 left-[calc(100%+1rem)] w-[calc(100%-2rem)] h-[1px] bg-white/10" />
              )}
              
              <div className="flex flex-col">
                {/* Step Number */}
                <div className="w-16 h-16 flex items-center justify-center border border-[#C9A962]/30 bg-[#C9A962]/5 mb-6">
                  <span className="text-[#C9A962] text-2xl font-semibold">
                    {String(step.step).padStart(2, '0')}
                  </span>
                </div>
                
                {/* Content */}
                <h3 className="text-xl font-semibold text-white mb-3">
                  {step.title}
                </h3>
                <p className="text-white/60 text-base leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
